import { IGetUsers } from '.'
import { axiosInstance } from '../../data/Https/axios-instance'

export const getUsers: IGetUsers = async () => {
  const { data } = await axiosInstance.get('/users')

  return data.content
}
